import { oneOf } from 'leanplum-lib-common';
import Vue, { VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { cx } from '../../utils/cx';
import { Icon } from '../icon/Icon';

require('./StatusIndicator.scss');

enum StatusIndicatorType {
  INACTIVE = 'inactive',
  ACTIVE = 'active',
  WARNING = 'warning'
}

@Component({ name: 'StatusIndicator' })
class StatusIndicator extends Vue {
  @Prop({ type: String, required: true })
  readonly label: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  readonly embedded: boolean;

  @Prop({
    type: String,
    required: false,
    default: StatusIndicatorType.INACTIVE,
    validator: oneOf(Object.values(StatusIndicatorType))
  })
  readonly type: StatusIndicatorType;

  render(): VNode {
    return (
      <div class={cx('lp-status-indicator', { embedded: this.embedded })}>
        <Icon class={cx('status-icon', this.type)} type={Icon.Type.STATUS_INDICATOR} />
        {this.label}
      </div>
    );
  }
}

namespace StatusIndicator {
  export const Type = StatusIndicatorType;
  export type Type = StatusIndicatorType;
}

export { StatusIndicator };
